import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams, ActionSheetController, ToastController, Platform, LoadingController, Loading } from 'ionic-angular';

import { Validators, FormBuilder, FormGroup, FormControl } from '@angular/forms';
//import { Http, Headers, RequestOptions } from '@angular/common/http';



import { Observable } from 'rxjs/Observable';
import { Injectable } from '@angular/core';
import { GlobalProvider } from "../../providers/global/global";
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { LoginPage } from '../login/login';
import { ReactivateotpPage } from '../reactivateotp/reactivateotp';
/**
 * Generated class for the ReactivatePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

//@IonicPage()
@Component({
  selector: 'page-reactivate',
  templateUrl: 'reactivate.html',
})
export class ReactivatePage {

  private vistor_reactivate : FormGroup;
  inverify = false;
  accesscode = "";
  otp = "";

  constructor(
    public navCtrl: NavController, 
    public navParams: NavParams,  
    private formBuilder: FormBuilder,
    private toastCtrl: ToastController, 
    public http: HttpClient,    
    public actionSheetCtrl: ActionSheetController, 
    public platform: Platform, 
    public loadingCtrl: LoadingController ,
    public global: GlobalProvider ) {
    this.vistor_reactivate = this.formBuilder.group({
      accesscode: [null],//['', Validators.required],
      otp: ['', Validators.required],
    })
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ForgotPage');
  }

  /*
  redirectPage(params:string){
    console.log('params = '+params);
    if(params == 'LoginPage')
      this.navCtrl.push(LoginPage);
    else if(params == 'CalendarPage')
      this.navCtrl.push(CalendarPage);
    else if(params == 'VideoPage')
      this.navCtrl.push(VideoPage);
    else if(params == 'DirectionsPage')
      this.navCtrl.push(DirectionsPage);
  }*/

  goback(){
    this.navCtrl.pop();
  }

  editAccessCode(){
    this.inverify = false;
    this.otp = "";
  }

  getOTP(){
    (<HTMLInputElement> document.getElementById('OTPBtn')).disabled=true;

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/json',
        'Accept': 'application/json'
      })
    };


    this.http.get(this.global.baseUrl+"api/admin/otp/generate?verificationCode="+this.accesscode, httpOptions)
      .subscribe((data:any) => {
        //console.log(data['_body']);
        //console.log(data);
        //console.log(data.error);
        if(data.error == true){
            //console.log(data.errorList[0].description);
            let toast = this.toastCtrl.create({
              message: data.errorList[0].description,
              duration: 20000,
              position: 'bottom',
              showCloseButton:true,
              closeButtonText:'Close'
            });

            toast.onDidDismiss(() => {
              console.log('Dismissed toast');
            });
          
            toast.present();
            (<HTMLInputElement> document.getElementById('OTPBtn')).disabled=false;
            
          }else{
            if(data.errorList.length == 0){
              let toast = this.toastCtrl.create({
                message: data.message,
                duration: 3000,
                position: 'bottom',
                showCloseButton:false,
                closeButtonText:'Close'
              });
  
              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });
            
              toast.present();
              (<HTMLInputElement> document.getElementById('OTPBtn')).disabled=false;
              this.navCtrl.push(ReactivateotpPage, {
                accesscode:this.accesscode 
              });
            }else{
              let toast = this.toastCtrl.create({
                message: 'OTP sent successfully!.',
                duration: 3000,
                position: 'bottom',
                showCloseButton:false,
                closeButtonText:'Close'
              });

              toast.onDidDismiss(() => {
                console.log('Dismissed toast');
              });
            
              toast.present();
              (<HTMLInputElement> document.getElementById('OTPBtn')).disabled=false;
              this.inverify = true;
            }
          }
        }, error => {
        console.log(error);
        let toast = this.toastCtrl.create({
          message: 'Error!.',
          duration: 3000,
          position: 'bottom',
          showCloseButton:false,
          closeButtonText:'Close'
        });

        toast.onDidDismiss(() => {
          console.log('Dismissed toast');
        });
      
        toast.present();
        (<HTMLInputElement> document.getElementById('OTPBtn')).disabled=false;
    });
  }

}



// WEBPACK FOOTER //
// ./src/pages/reactivate/reactivate.ts